(function IIFE() {
    'use strict';

    /////////////////////////////

    function FsitemsFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/media/fsitems/:methodKey', {}, {
            trash: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'delete',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('FsitemsFactory', FsitemsFactory);
})();
